import * as yup from "yup";

export const addingEmployeeSchema = yup.object().shape({
	firstName: yup.string().required("Обязательное поле"),
	lastName: yup.string().required("Обязательное поле"),
	middleName: yup.string().required("Обязательное поле"),
	tabNumber: yup.string().required("Обязательное поле"),
	orgId: yup.object().shape({
		name: yup.string().required("Обязательное поле"),
	}),
	orgRelationship: yup.object().shape({
		name: yup.string().required("Обязательное поле"),
	}),
	positionId: yup.object().shape({
		name: yup.string().required("Обязательное поле"),
	}),
	departmentId: yup.object().shape({
		name: yup.string().required("Обязательное поле"),
	}),
	employmentDate: yup.string().required("Обязательное поле"),
	statusId: yup.object().shape({
		name: yup.string().required("Обязательное поле"),
	}),
});
